import store from '@/store'

// ---------------- Mapping ---------------- //

export function mapEvents (events) {
  events.map(event => {
    let project = event ? store.getters['projects/byId']({ id: event.relationships.project.data && event.relationships.project.data.id }) : null
    let client = event ? store.getters['clients/byId']({ id: project.relationships.client.data && project.relationships.client.data.id }) : null
    let defaultActivity = event ? store.getters['activities/byId']({ id: event.relationships.defaultActivity.data && event.relationships.defaultActivity.data.id }) : null

    event.isPersonal = (event.attributes.tags || []).includes('FluxPersonal')
    event.project = project ? project.attributes.name : null
    event.projectPath = event.attributes.path ? event.attributes.path.replace(/\|/g, ' | ') : event.project
    event.path = event.projectPath
    event.client = client ? client.attributes.name : null
    event.defaultActivity = defaultActivity
    event.defaultActivityName = defaultActivity ? defaultActivity.attributes.name : '- - -'
    event.name = event.attributes.name
    event.priority = event.attributes.priority
    event.status = event.attributes.isDone ? 'Done' : event.attributes.isOnHold ? 'On Hold' : 'Active'
    event.taskString = event.client + ' | ' + event.projectPath + ' | ' + event.name
    event.start = event.attributes.start || null
  })

  return events
}
